/**
 * A global namespace for `Space` key.
 * e.which = 32 equivalent
 */
const keySpace = "Space";

export default keySpace;
